module.exports = __webpack_public_path__ + "img/Cellphone.62c876f6.png";